// extracted by mini-css-extract-plugin
export default {"dvideo":"About_dvideo__3FqiV","ddvideo":"About_ddvideo__zbi0z"};